import React from 'react';
import './styles/index.css';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import Header from './components/Header';
import SiteBanner from './components/SiteBanner';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import CartPage from './pages/CartPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import AccountPage from './pages/AccountPage';
import ProductTemplatePage from './pages/ProductTemplatePage';
import OrdersPage from './pages/OrdersPage';
import BuildYourAdPage from './pages/BuildYourAdPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ContactPage from './pages/ContactPage';

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};


const AppContent = () => {
  const location = useLocation();

  // Check if the current route is the login route
  const isAuthPage = location.pathname === '/auth';

  return (
    <div className="app-container">
      {!isAuthPage && <SiteBanner />}
      {!isAuthPage && <Header />}
      <div className="app-content">
        <Switch>
          <Route path="/" component={HomePage} exact />
          {/* <ProtectedRoute path="/dashboard" component={Dashboard} /> */}
          <Route path="/build-your-ad" component={BuildYourAdPage} />
          <Route path="/promotions" component={ProductsPage} />
          <Route path="/product/:productId" component={ProductDetailPage} />
          <Route path="/cart" component={CartPage} />
          <Route path="/reset-password/:token" component={ResetPasswordPage} />
          <Route path="/orders" component={OrdersPage} />
          <Route path="/account" component={AccountPage} />
          <Route path="/contact" component={ContactPage} />
          <Route path="/product/:productId/template" component={ProductTemplatePage} />
        </Switch>
      </div>

      <Footer />
    </div>
  );
};

export default App;
